import {ComponentFactoryResolver, Directive, OnDestroy, TemplateRef, ViewContainerRef} from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {RouterService} from "../../services/router.service";
import {Subscription} from "rxjs";
import {RouterOutletComponent} from "../../components/router-outlet/router-outlet.component";

@Directive({ selector: '[routerOuter]' })
export class RouterOuterDirective implements OnDestroy {

  isOuter: boolean = this.routerService.isOuter(this.route.children);
  routesChange: Subscription;

  constructor(private route: ActivatedRoute,
              private routerService: RouterService,
              private componentFactoryResolver: ComponentFactoryResolver,
              private templateRef: TemplateRef<any>,
              private viewContainer: ViewContainerRef) {
    this.routesChange = this.routerService.outerChange(this.route).subscribe((result) => {
      if (this.isOuter == result) return;

      this.isOuter = result;

      this.setView();
    });

    this.setView();
  }

  ngOnDestroy() {
    this.routesChange.unsubscribe();
  }

  setView() {
    this.viewContainer.clear();
    if (this.isOuter) {
      let routerOutletComponent = this.componentFactoryResolver.resolveComponentFactory(RouterOutletComponent);
      this.viewContainer.createComponent(routerOutletComponent);
    } else {
      this.viewContainer.createEmbeddedView(this.templateRef);
    }
  }
}
